/** @format */

import * as React from 'react';
import { Spinner } from './LoadingSpinner.style';

interface LoadingSpinnerProps {
  className?: string;
}

const LoadingSpinner = React.forwardRef<HTMLDivElement, LoadingSpinnerProps>((props, ref) => {
  return <Spinner {...props} />;
});

LoadingSpinner.displayName = 'LoadingSpinner';

export { LoadingSpinner };
